





import { defineComponent, PropType, ref } from "@vue/composition-api";
import { LiveChatUser } from "@scrile/api-provider/dist/api/LivechatsProvider";
import providers from "@/lib/api";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "MuteController",
  components: { BaseIconButton },
  props: {
    viewer: { type: Object as PropType<LiveChatUser>, required: true },
  },
  setup(props) {
    const loading = ref(false);
    const toggleMute = async () => {
      try {
        loading.value = true;
        await providers.LivechatsProvider.userUpdate({
          data: { chatUserId: props.viewer.id, muted: !props.viewer.muted },
        });
      } finally {
        loading.value = false;
      }
    };

    return { loading, toggleMute };
  },
});
